import JsonLd from "@/components/base/JsonLd";
import useSeo from "@/hooks/useSeo";
import Hero from "@/pages/home/components/Hero";
import LatestScoops from "@/pages/home/components/LatestScoops";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import TopicShowcase from "@/pages/home/components/TopicShowcase";
import SubmitProcess from "@/pages/home/components/SubmitProcess";
import PrivacyPromise from "@/pages/home/components/PrivacyPromise";
import FaqPreview from "@/pages/home/components/FaqPreview";
import SubmitCta from "@/pages/home/components/SubmitCta";
import { faqs } from "@/mocks/faqs";
import { site } from "@/config/site";

const ORIGIN = "https://of659.cn";

export default function Home() {
  useSeo({
    title: "看料爆料 - 匿名投稿平台｜提交线索、私信投稿、快速核实猛料",
    description:
      "看料爆料是面向中文读者的爆料线索投稿平台，提供匿名投稿、私信投稿与线索提交入口，快速筛选核实内幕素材，帮助投稿人降低曝光风险，让每一条真料安全见光。",
    keywords: "看料爆料,看料爆料投稿,看料爆料私信,爆料线索提交,匿名爆料平台,行业内幕爆料",
    canonical: `${ORIGIN}/`,
  });

  const faqPreview = faqs.slice(0, 5);

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: site.name,
      url: `${ORIGIN}/`,
      description: site.intro,
      inLanguage: "zh-CN",
      potentialAction: {
        "@type": "SearchAction",
        target: `${ORIGIN}/scoops?q={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: site.name,
      url: `${ORIGIN}/`,
      description: site.intro,
      email: site.email,
      foundingDate: site.since,
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqPreview.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: { "@type": "Answer", text: item.a },
      })),
    },
  ];

  return (
    <>
      <JsonLd data={jsonLd} />
      <Hero />
      <LatestScoops />
      <CategoryGrid />
      <TopicShowcase />
      <SubmitProcess />
      <PrivacyPromise />
      <FaqPreview />
      <SubmitCta />
    </>
  );
}